import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {
  id: string;
};

const deleteProduct = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminProduct/deleteProduct',
    method: 'DELETE',
    params,
  });

export { deleteProduct };
